import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { formatApiError } from "@/lib/auth";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      toast.success("Password updated. Please log in.");
      navigate("/login");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="dark flex min-h-screen items-center justify-center bg-[#03050A] px-4 text-slate-200">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-cyan-900/40 bg-slate-950/70 p-6">
        <h1 className="mb-4 font-display text-xl font-extrabold uppercase text-white">Reset Password</h1>
        {!token && <p className="mb-3 font-mono text-[11px] text-rose-400">Missing reset token.</p>}
        <Input type="password" required placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)}
          className="mb-3 border-slate-800 bg-slate-900/60 text-slate-100" />
        {err && <p className="mb-2 font-mono text-[11px] text-rose-400">{err}</p>}
        <Button type="submit" disabled={busy || !token} className="w-full gap-2 bg-cyan-500 font-mono text-xs font-bold uppercase tracking-widest text-slate-950 hover:bg-cyan-400">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Update Password
        </Button>
      </form>
    </div>
  );
}
